var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgClockRewindicon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockRewindicon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;